// Lightweight replacement for file-saver to remove CommonJS dependency.
// Supports modern browsers and IE11 fallback (msSaveOrOpenBlob / msSaveBlob).
export function saveBlob(data: Blob | ArrayBuffer | Uint8Array, filename: string, mime = 'text/csv'): void {
  const blob = data instanceof Blob ? data : new Blob([data as BlobPart], { type: mime });
  const nav: any = window.navigator;
  if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
    nav.msSaveOrOpenBlob(blob, filename);
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
